// extracted by mini-css-extract-plugin
export default {"PlusButton":"AddMessageCard_PlusButton__R8nIa","AlignButton":"AddMessageCard_AlignButton__dSHwz"};